import Joi from 'joi';

export const LoginPayloadSchema = Joi.object({
  email: Joi.string(),
  password: Joi.string(),
});

export const LoginByEmailPayloadSchema = Joi.object({
  email: Joi.string(),
  recaptchaToken: Joi.string(),
});

export const LoginResponseSchema = Joi.object({
  access_token: Joi.string(),
  message_en: Joi.string(),
  template: Joi.string(),
  id: Joi.number(),
});
